// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticleFeedback_title__9Ih3i","buttons":"ArticleFeedback_buttons__oisbe","successIcon":"ArticleFeedback_successIcon__1s0zK","wrapper":"ArticleFeedback_wrapper__eWre9"};